import { FC, memo } from 'react'
import { Modal } from 'components/layouts/modal/modal'
import { TaskEntryByTemplateForm } from './components/taskEntryByTemplateForm/taskEntryByTemplateForm'
import { useTranslation } from '@crew/modules/i18n'

export type TaskEntryByTemplateDialogProps = {
  isOpen: boolean
  onSubmit: () => void
  onClose: () => void

  // 「テンプレートからタスク登録」の対象となるプロジェクトID
  projectId: string
}

// 「テンプレートからタスク登録」ダイアログ
export const TaskEntryByTemplateDialog: FC<TaskEntryByTemplateDialogProps> =
  memo((props) => {
    const { t } = useTranslation()
    return (
      <Modal
        id="task-entry-by-template-dialog"
        title={t('label.taskTemplate.addTaskByTemplateTitle')}
        isOpen={props.isOpen}
        onClose={props.onClose}
        className="lg:min-w-[75vw] min-h-[80vh]"
      >
        <TaskEntryByTemplateForm
          projectId={props.projectId}
          isOpen={props.isOpen}
          onSubmit={props.onSubmit}
          onCancel={props.onClose}
        />
      </Modal>
    )
  })
